import { z } from "zod";
import { gql } from "graphql-request";

export const SysSchema = z.object({
  id: z.string(),
  publishedAt: z.string().nullable(),
  firstPublishedAt: z.string().nullable(),
  publishedVersion: z.number().nullable(),
});

export const Sys = SysSchema;
export type Sys = z.infer<typeof SysSchema>;

export const SysFragment = gql`
  fragment SysFragment on Sys {
    id
    publishedAt
    firstPublishedAt
    publishedVersion
  }
`;
